import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider, Navigate, Outlet } from 'react-router-dom';

import React, { useContext } from 'react';
import { GlobalContext } from '../../App';

// lyouts
import Graves from '../pages/pagesMains/GravesManagers/Graves';

import CemeteryDetail from '../pages/pagesDetails/CemeteryDetail';
import BlockDetail from '../pages/pagesDetails/BlockDetail';
import PlotDetail from '../pages/pagesDetails/PlotDetail';
import AreaGraveDetail from '../pages/pagesDetails/AreaGraveDetail';

import CemeteryHome from '../pages/pagesHome/CemeteryHome';
import BlockHome from '../pages/pagesHome/BlockHome';
import PlotHome from '../pages/pagesHome/PlotHome';
import AreaGraveHome from '../pages/pagesHome/AreaGraveHome';
import PurchasesHome from '../pages/pagesHome/PurchasesHome';
import BurialsHome from '../pages/pagesHome/BurialsHome';
import PaymentsHome from '../pages/pagesHome/PaymentsHome';

import CemeteryCreate from '../pages/pagesCreate/cemeteryCreate';
import BlockCreate from '../pages/pagesCreate/blockCreate';
import PlotCreate from '../pages/pagesCreate/plotCreate';
import GraveCreate from '../pages/pagesCreate/graveCreate';
import PurchaseCreate from '../pages/pagesCreate/purchaseCreate';
import BurialCreate from '../pages/pagesCreate/burialCreate';
import CustomerCreate from '../pages/pagesCreate/customerCreate';
import PaymentCreate from '../pages/pagesCreate/paymentCreate';
import CountryCreate from '../pages/pagesCreate/countryCreate';
import CityCreate from '../pages/pagesCreate/cityCreate';

import CemeteryUpdate from '../pages/pagesUpdate/cemeteryUpdate';
import BlockUpdate from '../pages/pagesUpdate/blockUpdate';
import PlotUpdate from '../pages/pagesUpdate/plotUpdate';
import GraveUpdate from '../pages/pagesUpdate/graveUpdate';
import BurialUpdate from '../pages/pagesUpdate/burialUpdate';
import PurchaseUpdate from '../pages/pagesUpdate/purchaseUpdate';
import CustomerUpdate from '../pages/pagesUpdate/customerUpdate';
import PaymentUpdate from '../pages/pagesUpdate/paymentUpdate';
import ReportsDashboard from '../pages/pagesHome/reports/indexReports';
import GraveStatusReport from '../pages/pagesHome/reports/graveStatusReport';
import SignInSide from '../pages/pagesMains/connection/SignInSide';
import SearchBar from '../pages/pagesTesting/SearchBar';
import CustomGrid from '../pages/pagesTesting/CustomGrid';
import CustomTooltip from '../pages/pagesTesting/CustomTooltip';
import DraggableList from '../pages/pagesTesting/handleToggleExpand';
import RegistrationForm from '../pages/pagesMains/connection/RegistrationForm';
import GlobalSearchDashboard from '../pages/pagesDashboard/GlobalSearchDashboard';
import BookkeepingDashboard from '../pages/pagesDashboard/BookkeepingDashboard';
import DontAccess from '../pages/pagesAccessories/DontAccess';
import { useSelector } from 'react-redux';
import PrintReport from '../pages/pagesHome/reports/print';
import GraveDetailReport from '../pages/pagesHome/reports/GraveDetailReport';
import UploadExcelForm from '../pages/pagesTesting/UploadExcelForm';
import ExcelUploader from '../pages/pagesTesting/ExcelUploader';
import ExcelProcessor from '../pages/pagesTesting/ExcelProcessor';
import TableComponent from '../pages/pagesHome/TableComponent';
import CustomersHome from '../pages/pagesHome/CustomersHome';
import Decryptor from '../pages/pagesTesting/Decryptor';
import UpdateRecordsForm from '../pages/pagesTesting/UpdateRecordsForm';
import ExcelForm from '../pages/settings/BLBild';
// import ParentComponent from '../pages/plagins/form/ParentComponent';
import FormWrapper from '../pages/plagins/form/testForm';
import ParentComponent from '../pages/plagins/ModularForms/ParentComponent';
import CityDefinitionForm from '../pages/settings/DefinitionOfResidency';
import ResponsiveBoxWithSidebar from '../pages/settings/indexSettings';

const RouterApp = () => {
  const { token, userId, permission } = useContext(GlobalContext);
  const cemeteryPermissions = [1];
  const blockPermissions = [1];
  const plotPermissions = [1];
  const areaGravePermissions = [1, 3];
  const customerPermissions = [1];
  const purchasePermissions = [1];
  const burialPermissions = [1];
  const paymentPermissions = [1];
  const reportPermissions = [1];
  const isCemeteryPermission = permission === 0 || cemeteryPermissions.includes(permission);
  const isBlockPermission = permission === 0 || blockPermissions.includes(permission);
  const isPlotPermission = permission === 0 || plotPermissions.includes(permission);
  const isAreaGravePermission = permission === 0 || areaGravePermissions.includes(permission);
  const isCustomerPermission = permission === 0 || customerPermissions.includes(permission);
  const isPurchasePermission = permission === 0 || purchasePermissions.includes(permission);
  const isBurialPermission = permission === 0 || burialPermissions.includes(permission);
  const isPaymentPermission = permission === 0 || paymentPermissions.includes(permission);
  const isReportPermission = permission === 0 || reportPermissions.includes(permission);

  // קבלת דף הבית מה-Redux
  const homePage = useSelector((state) => state.homePage.data);

  const router = createBrowserRouter(
    createRoutesFromElements(
      token && token !== undefined && token !== null && token !== '' ? (
        <Route path="/" element={<Graves key={0} />}>
          <Route index element={<Navigate to={`/${homePage.find((home) => home.userId.includes(parseInt(userId)))?.navigator}`} />} />

          <Route path="cemetery" element={isCemeteryPermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<CemeteryHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<CemeteryDetail />} />
              <Route path=":id" element={<Outlet />}>
                <Route index element={<BlockDetail />} />
                <Route path=":id" element={<Outlet />}>
                  <Route index element={<PlotDetail />} />
                  <Route path=":id" element={<Outlet />}>
                    <Route index element={<AreaGraveDetail />} />
                  </Route>
                  <Route path="areaGraveCreate" element={<GraveCreate />} />
                </Route>
                <Route path="plotCreate" element={<PlotCreate />} />
              </Route>
              <Route path="blockCreate" element={<BlockCreate />} />
            </Route>
            <Route path="cemeteryCreate" element={<CemeteryCreate />} />
          </Route>

          <Route path="block" element={isBlockPermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<BlockHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<BlockDetail />} />
              <Route path=":id" element={<Outlet />}>
                <Route index element={<PlotDetail />} />
                <Route path=":id" element={<Outlet />}>
                  <Route index element={<AreaGraveDetail />} />
                </Route>
                <Route path="areaGraveCreate" element={<GraveCreate />} />
              </Route>
              <Route path="plotCreate" element={<PlotCreate />} />
            </Route>
            <Route path="blockCreate" element={<BlockCreate />} />
          </Route>

          <Route path="plot" element={isPlotPermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<PlotHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<PlotDetail />} />
              <Route path=":id" element={<Outlet />}>
                <Route index element={<AreaGraveDetail />} />
              </Route>
              <Route path="areaGraveCreate" element={<GraveCreate />} />
            </Route>
            <Route path="plotCreate" element={<PlotCreate />} />
          </Route>

          <Route path="areaGrave" element={isAreaGravePermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<AreaGraveHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<AreaGraveDetail />} />
            </Route>
            <Route path="areaGraveCreate" element={<GraveCreate />} />
          </Route>

          <Route path="customer" element={isCustomerPermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<CustomersHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<CustomerUpdate />} />
            </Route>
            <Route path="customerCreate" element={<CustomerCreate />} />
          </Route>

          <Route path="purchase" element={isPurchasePermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<PurchasesHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<PurchaseUpdate />} />
            </Route>
            <Route path="purchaseCreate" element={<PurchaseCreate />} />
          </Route>

          <Route path="burial" element={isBurialPermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<BurialsHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<BurialUpdate />} />
            </Route>
            <Route path="burialUpdate" element={<BurialUpdate />} />
          </Route>

          <Route path="payment" element={isPaymentPermission ? <Outlet /> : <Navigate to="/dontAccess" />}>
            <Route index element={<PaymentsHome />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<PaymentUpdate />} />
            </Route>
            <Route path="paymentCreate" element={<PaymentCreate />} />
          </Route>

          <Route path="reports" element={isReportPermission ? <ReportsDashboard /> : <Navigate to="/dontAccess" />} />
          <Route path="GraveStatusReport" element={<GraveStatusReport />} />
          <Route path="PrintReport" element={<PrintReport />} />
          <Route path="GraveDetailReport" element={<GraveDetailReport />} />

          <Route path="SearchBar" element={<SearchBar />} />
          <Route path="CustomGrid" element={<CustomGrid />} />
          <Route path="CustomTooltip" element={<CustomTooltip />} />
          <Route path="DraggableList" element={<DraggableList />} />

          <Route path="cemeteryUpdate" element={<CemeteryUpdate />} />
          <Route path="blockUpdate" element={<BlockUpdate />} />
          <Route path="plotUpdate" element={<PlotUpdate />} />
          <Route path="areaGraveUpdate" element={<GraveUpdate />} />

          <Route path="customerUpdate" element={<CustomerUpdate />} />
          <Route path="purchaseCreate" element={<PurchaseCreate />} />
          <Route path="purchaseUpdate" element={<PurchaseUpdate />} />
          <Route path="burialCreate" element={<BurialCreate />} />
          <Route path="burialUpdate" element={<BurialUpdate />} />

          <Route path="countryCreate" element={<CountryCreate />} />
          <Route path="cityCreate" element={<CityCreate />} />
          <Route path="globalSearch" element={<GlobalSearchDashboard />} />
          <Route path="bookkeepingDashboard" element={<BookkeepingDashboard />} />

          <Route path="dontAccess" element={<DontAccess imageSrc={'/dontAccess.png'} text={'אין מספיק הרשאות'} />} />

          <Route path="registerG1234" element={<RegistrationForm />} />
          <Route path="uploadG1234" element={<UploadExcelForm />} />
          <Route path="UpdateRecords" element={<UpdateRecordsForm />} />

          <Route path="exelG1234" element={<ExcelUploader />} />
          <Route path="exelP1234" element={<ExcelProcessor />} />
          <Route path="Decryptor" element={<Decryptor />} />
          <Route path="BLBild" element={<ExcelForm />} />
          <Route path="ParentComponent" element={<ParentComponent />} />
          <Route path="ParentComponent" element={<FormWrapper />} />
          <Route path="CityDefinitionForm" element={<CityDefinitionForm />} />
          <Route path="ResponsiveTemplate" element={<ResponsiveBoxWithSidebar />} />
          
          
          

          <Route path="component" element={<TableComponent />} />


        </Route>
      ) : (
        <Route path="/" element={<SignInSide />}>
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      )
    )
  );

  return <RouterProvider router={router} />;
};
export default RouterApp;
